import Button from "./Button"
import { auth } from "../services/auth"
import { useState } from "react"
export const LogoutButton = ({ props }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const handleLogout = () => {
    setIsSubmitting(true)
    auth.logout().then(() => {
      setIsSubmitting(false)
    })
  }
  return (
    <Button
      variant={"secondary"}
      padding={"px-6 py-2"}
      disabled={isSubmitting}
      onClick={handleLogout}
      {...props}
    >
      {isSubmitting ? "Logging out..." : "Logout"}
    </Button>
  )
}
